module.exports = __webpack_public_path__ + "img/points.4f1a6b6c.jpg";